<ng-container *ngIf="portalLead$ | async as portalLead">
  <ng-container *ngTemplateOutlet="newTemplate; context: { portalLead }"></ng-container>
</ng-container>

<ng-template #newTemplate let-portalLead="portalLead">
  <div class="d-flex flex-column p-4">
    <div class="d-flex flex-column done-card">
      <img src="assets/icons/done.svg" alt="done" width="48" height="48" />

      @if (portalOrder.isChange) {
        @if (hasSelectedProtection) {
          <h2 class="semi-bold mt-6">Your protection has been saved</h2>

          <p class="mt-3">
            You’ve successfully saved your travel protection for this trip. If you have any
            questions or need help later on — we’re just a message away. Safe trip and happy
            travels!
          </p>
        } @else {
          <h2 class="semi-bold mt-6">You’ve decided to travel without extra protection</h2>

          <p class="mt-3">
            You decided to skip protection this time. If you have any questions or need help later
            on — we’re just a message away. Safe trip and happy travels!
          </p>
        }
      } @else {
        <h2 class="semi-bold mt-6">Done! We are now working on booking your tickets</h2>

        <p class="mt-3">Tickets will be sent to your email</p>
        <!-- <p class="mt-1">Booking No. <b>723480</b></p>
        <p class="mt-1">Texas → Milan • Aug 10 – Aug 18</p> -->
      }
    </div>

    @if (!portalOrder.isChange) {
      <div class="d-flex flex-column mt-4 preferences-card">
        @if (isNewUser) {
          <h2 class="semi-bold">Add a few more details to help us make your journey perfect</h2>

          <div class="mt-6 points">
            <span class="point full"></span>
            <p>Routes and dates: 100%</p>

            <span class="point semi"></span>
            <p>Personal details: 60%</p>

            <span class="point"></span>
            <p>Meal preferences: 0%</p>

            <span class="point"></span>
            <p>Seat preferences: 0%</p>

            <span class="point"></span>
            <p>Frequent flyer details: 0%</p>
          </div>
        } @else {
          <h2 class="semi-bold">Please review and update all passenger preferences</h2>
        }
      </div>
    }
    @if (portalOrder.isChange) {
      <h2 class="semi-bold mt-4 mt-md-6">Sign in to see your trip</h2>
    } @else {
      @if (isNewUser) {
        <h2 class="semi-bold mt-4 mt-md-6">Sign up to complete these details for all travelers</h2>
      } @else {
        <h2 class="semi-bold mt-4 mt-md-6">Sign in to update passenger preferences</h2>
      }
    }

    <ng-container *ngIf="user$ | async; else signInTemplate">
      <ds-button
        (click)="continue()"
        [fullWidth]="true"
        class="mt-4 mt-md-6"
        data-id="continue"
        label="Continue"
      />
    </ng-container>

    <ng-template #signInTemplate>
      <div class="mt-4 mt-md-6 d-flex flex-column flex-md-row">
        <ds-button
          (click)="continueWith(CognitoHostedUIIdentityProvider.Google)"
          [attr.data-redirect-url]="redirectUrl"
          variant="secondary"
          leadingIcon="google"
          [fullWidth]="true"
          class="flex-1"
          data-id="google"
          label="Continue with Google"
        />

        <ds-button
          (click)="continueWith(CognitoHostedUIIdentityProvider.Facebook)"
          variant="secondary"
          leadingIcon="facebook"
          [fullWidth]="true"
          class="mt-4 mt-md-0 ml-md-4 flex-1"
          data-id="facebook"
          label="Continue with Facebook"
        />
      </div>

      <p class="mt-4 mx-auto">or</p>

      <div class="mt-4 form">
        <form [formGroup]="form">
          <ds-input
            (focusin)="focus()"
            formControlName="email"
            [error]="form.errors ? activationError || undefined : undefined"
            label="Email"
            placeholder="Email"
            type="email"
            data-id="email"
          />

          <p *ngIf="form.errors" class="d-none" data-id="error">
            {{ activationError }}
          </p>
        </form>

        @let commonData = commonDataService.getData() | async;

        <p class="d-md-none mt-3 caption text-jazlyn-700">
          By clicking the «Continue» button, you are agreeing to the {{ commonData?.label }} terms
          and conditions and to being automatically registered in our system.
        </p>

        <ds-button
          (click)="submit()"
          [disabled]="loading || form.invalid"
          [fullWidth]="true"
          class="mt-4 mt-md-6"
          data-id="send-email"
          label="Continue"
        />
      </div>

      <p class="d-none d-md-inline mt-3 caption text-jazlyn-700">
        By clicking the «Continue» button, you are agreeing to the {{ commonData?.label }} terms and
        conditions and to being automatically registered in our system.
      </p>
    </ng-template>
  </div>
</ng-template>
